import classNames from "classnames"
import FavoriteButton from "legacy/FavoriteButton"
import PropTypes from "prop-types"
import React from "react"

import { DockwaPlusDealLogoWhiteWithGradient } from "src/components/DockwaPlus/Logos"

class MapMarinaSearchCard extends React.Component {
  constructor(props) {
    super(props)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onClick = this.onClick.bind(this)
    this.handleAmplitude = this.handleAmplitude.bind(this)
  }

  renderRating() {
    const { review_count, rating } = this.props.marina
    if (review_count > 0) {
      return (
        <div className="flex items-center space-x-1 whitespace-nowrap">
          <i className="icon icon-star text-yellow-600" />
          <span>{`${Math.round(rating * 10) / 10} (${review_count})`}</span>
        </div>
      )
    }
  }

  dockText() {
    if (this.props.marina.has_dock) {
      return <div className="badge badge-teal">Dock</div>
    }
  }

  mooringText() {
    if (this.props.marina.has_mooring) {
      return <div className="badge badge-teal">Mooring</div>
    }
  }

  dayTripText() {
    if (this.props.marina.has_day_trip) {
      return <div className="badge badge-teal">Day Trip</div>
    }
  }

  boatUS() {
    if (this.props.marina.has_boatus) {
      return <img src={this.props.marina.boatus_img_url} alt="BoatUS Logo" />
    }
  }

  dockwaDeal() {
    if (this.props.marina.has_dockwa_plus_deal) {
      return <DockwaPlusDealLogoWhiteWithGradient />
    }
  }

  cloudinaryImage() {
    const { marina_photo } = this.props.marina
    if (marina_photo) {
      return "url(" + marina_photo + ") no-repeat center center"
    } else {
      return "#eee"
    }
  }

  renderOfferings() {
    if (!this.props.marina.online_booking) {
      return (
        <div className="badge badge-gray mt-4 w-min whitespace-nowrap">
          Inquiry Only
        </div>
      )
    }
    if (this.dockText() || this.mooringText() || this.dayTripText()) {
      return (
        <div className="mt-4 flex space-x-2">
          {this.dockText()}
          {this.mooringText()}
          {this.dayTripText()}
        </div>
      )
    }
  }

  onMouseEnter() {
    if (this.props.hoverMarina) {
      this.props.hoverMarina(this.props.marina.id)
    }
  }

  onMouseLeave() {
    if (this.props.blurMarina) {
      this.props.blurMarina()
    }
  }

  onClick() {
    this.handleAmplitude()
  }

  isMobile() {
    return window.innerWidth < 738
  }

  handleAmplitude() {
    const { mcom_id, name, visible_form } = this.props.marina
    if (this.props.experienceName) {
      const destinationPressedExperiences = [
        "destination_detail",
        "explore_collection",
        "home",
        "search",
      ]
      if (destinationPressedExperiences.includes(this.props.experienceName)) {
        Amplitude.trackEvent(
          `${this.props.experienceName}:destination_pressed`,
          {
            experience_name: this.props.experienceName,
            marina_id: mcom_id,
            card_position: this.props.cardPosition,
            marina_name: name,
            search_term: this.props.searchTerm,
            search_id: this.props.searchId,
            visible_form,
          }
        )
      }
    }
  }

  renderMarinaImage() {
    const { marina_photo } = this.props.marina
    return (
      <div className="relative min-h-36 w-full overflow-hidden lg:w-52">
        <img
          src={marina_photo}
          alt={this.props.marina.name}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    )
  }

  renderFuel() {
    const {
      prioritized_fuel: prioritizedFuel,
      fuel_prices_last_updated_text: fuelPricesLastUpdatedText,
    } = this.props.marina
    if (prioritizedFuel && prioritizedFuel.length > 0) {
      return (
        <div className="mt-4 flex items-start space-x-2 lg:items-center">
          <i className="icon icon-fuel -mt-0.5 text-xl lg:mt-0" />
          <div className="flex flex-col items-start space-y-1 lg:flex-row lg:items-center lg:space-x-2 lg:space-y-0">
            <div className="flex items-center space-x-2">
              {prioritizedFuel.map((fuel, index) => (
                <div key={index} className="flex space-x-1 text-sm">
                  <span className="whitespace-nowrap font-semibold">
                    {fuel.name}
                  </span>
                  <span>{fuel.price_dollars}</span>
                </div>
              ))}
            </div>
            <span className="text-sm text-gray-600">
              Updated {fuelPricesLastUpdatedText}
            </span>
          </div>
        </div>
      )
    }
  }

  renderDockwaPlusDiscounts() {
    const {
      best_dockage_discount: bestDockageDiscount,
      best_fuel_discount: bestFuelDiscount,
    } = this.props.marina

    if (bestDockageDiscount || bestFuelDiscount) {
      return (
        <div className="flex flex-col">
          <div className="my-4 w-full bg-gradient-to-b from-blue-200 to-blue-50 p-px" />
          <div className="flex w-full items-start space-x-2 font-semibold lg:items-center">
            <div>{this.dockwaDeal()}</div>
            <div className="flex flex-col items-start space-x-0 space-y-2 lg:flex-row lg:items-center lg:space-x-2 lg:space-y-0">
              {bestDockageDiscount && (
                <div className="flex items-center space-x-1 text-blue-500">
                  <i className="icon icon-tag-outline text-xl" />
                  <span>{bestDockageDiscount.discount}% off select dates</span>
                </div>
              )}
              {bestFuelDiscount && (
                <div className="flex items-center space-x-1 text-supplementary-orange-600">
                  <i className="icon icon-tag-outline text-xl" />
                  <span>{bestFuelDiscount.readable_discount} fuel</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    }
  }

  renderCardBody() {
    const { city, state, country, name } = this.props.marina
    return (
      <div className="flex h-full w-full justify-between rounded-b bg-white p-4 lg:rounded-r">
        <div className="flex h-full w-full flex-col">
          <div className="flex flex-col">
            <span className="w-112 overflow-hidden truncate text-lg font-semibold">
              {name}
            </span>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-600">
                {city}, {state || country}
              </span>
              {this.renderRating()}
              {this.boatUS()}
            </div>
          </div>
          {this.renderOfferings()}
          {this.renderFuel()}
          {this.renderDockwaPlusDiscounts()}
        </div>
      </div>
    )
  }

  renderOnlineBookingBadge() {
    return (
      <div className="absolute left-2 top-2">
        <span className="inline-block whitespace-nowrap rounded bg-teal-100 px-2 py-1 text-sm font-bold text-teal-900">
          Online Booking
        </span>
      </div>
    )
  }

  render() {
    const {
      id,
      slug,
      name,
      online_booking,
      mcom_id,
      is_favorite,
      visible_form,
    } = this.props.marina
    return (
      <div
        id={`marina-card-${id}`}
        className="relative col-span-12 min-w-[300px]"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div
          className={classNames("flex h-full w-full rounded p-px", {
            "bg-gradient-to-b from-blue-200 to-blue-50":
              this.props.marina.has_dockwa_plus_deal,
            "bg-gray-200": !this.props.marina.has_dockwa_plus_deal,
          })}
        >
          <a
            className="relative flex h-full w-full cursor-pointer flex-col overflow-hidden rounded bg-white text-gray-900 no-underline shadow-base lg:flex-row"
            href={`/explore/destination/${slug}${this.props.utm || ""}`}
            onClick={this.handleAmplitude}
            onFocus={this.onMouseEnter}
            onBlur={this.onMouseLeave}
            rel="noreferrer"
          >
            <span className={"sr-only"}>{`Navigate to ${name}`}</span>
            {this.renderMarinaImage()}
            {this.renderCardBody()}
            {online_booking && this.renderOnlineBookingBadge()}
            <div className="absolute right-4 top-2">
              <FavoriteButton
                marinaId={slug}
                mcomId={mcom_id}
                marinaName={name}
                isFavorite={is_favorite}
                compact={true}
                experienceName={this.props.experienceName}
                visibleForm={visible_form}
                imageOverlay={this.isMobile()}
              />
            </div>
          </a>
        </div>
      </div>
    )
  }
}

MapMarinaSearchCard.propTypes = {
  marina: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    marina_photo: PropTypes.string,
    review_count: PropTypes.number,
    rating: PropTypes.number,
    has_dock: PropTypes.bool,
    has_mooring: PropTypes.bool,
    has_day_trip: PropTypes.bool,
    has_boatus: PropTypes.bool,
    has_dockwa_plus_deal: PropTypes.bool,
    boatus_img_url: PropTypes.string,
    online_booking: PropTypes.bool,
    mcom_id: PropTypes.string,
    is_favorite: PropTypes.bool,
    visible_form: PropTypes.string,
    prioritized_fuel: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        price_dollars: PropTypes.string,
      })
    ),
    fuel_prices_last_updated_text: PropTypes.string,
    best_dockage_discount: PropTypes.shape({
      discount: PropTypes.number,
    }),
    best_fuel_discount: PropTypes.shape({
      readable_discount: PropTypes.string,
    }),
  }).isRequired,
  experienceName: PropTypes.string,
  utm: PropTypes.string,
  cardPosition: PropTypes.number,
  searchTerm: PropTypes.string,
  searchId: PropTypes.string,
  hoverMarina: PropTypes.func,
  blurMarina: PropTypes.func,
}

export default MapMarinaSearchCard
